const collator = new Intl.Collator('es', { numeric: true, sensitivity: 'base' })

export const sortTableRows = (rows, column, direction, selectors) => {
  const select = selectors[column]
  if (!select) return rows

  return [...rows].sort((left, right) => {
    const a = select(left)
    const b = select(right)
    if (a == null && b == null) return 0
    if (a == null) return 1
    if (b == null) return -1
    const result = typeof a === 'number' && typeof b === 'number'
      ? a - b
      : collator.compare(String(a), String(b))
    return direction === 'desc' ? -result : result
  })
}

export const toggleTableSort = (current, column) => ({
  column,
  direction: current.column === column && current.direction === 'asc' ? 'desc' : 'asc',
})
